import { usePremiumEssentialsContext } from '@wix/premium-fed-sdk/@premium-essentials';
import { ExperimentSpecs } from '../../../constants';
import { useIsSubmittedDomainTaken } from '../../../hooks/useIsSubmittedDomainTaken';
import { TldOfferWidgetModule, TldStripComponentName } from '../../../module/TldOfferWidget';
const TLD_STRIP_COMPONENT_BY_VARIANT = {
  A: TldStripComponentName.NONE,
  B: TldStripComponentName.EXPAND,
  C: TldStripComponentName.CAROUSEL
};
export const useBmTldStripVariant = _ref => {
  let domain = _ref.domain,
    enabled = _ref.enabled;
  const isSubmittedDomainTaken = useIsSubmittedDomainTaken();
  const _usePremiumEssentials = usePremiumEssentialsContext(),
    experiments = _usePremiumEssentials.experiments;
  const experimentVariant = experiments != null && experiments[ExperimentSpecs.BmTldStripB] ? 'B' : experiments != null && experiments[ExperimentSpecs.BmTldStripC] ? 'C' : 'A';
  const isTakenDomainSearch = enabled && Boolean(domain) && isSubmittedDomainTaken;
  TldOfferWidgetModule.SDK.useEligibilityReport({
    domain: domain ?? '',
    componentName: TLD_STRIP_COMPONENT_BY_VARIANT[experimentVariant],
    enabled: isTakenDomainSearch
  });
  return isTakenDomainSearch ? experimentVariant : 'A';
};
//# sourceMappingURL=useBmTldStripVariant.js.map